import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Row, Col, Card, Typography } from 'antd';
import {
  XAxis,
  YAxis,
  Tooltip as ReTooltip,
  Legend,
  AreaChart,
  BarChart,
  Bar,
  Area,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
} from 'recharts';

class DashboardChart extends Component {
  constructor(props) {
    super(props);
  }

  getLegendText = (name, { payload }) => {
    return `${name} (${payload.value})`;
  };

  render() {
    const { day_by_day_activities, productwise_activity } = this.props;
    const COLORS = [
      '#5AA08D',
      '#4C92B1',
      '#C8707E',
      '#EEE117',
      '#E48E58',
      '#E28FAD',
      '#97F19E',
      '#5AA08D',
      '#4C92B1',
      '#C8707E',
      '#EEE117',
      '#E48E58',
      '#E28FAD',
      '#97F19E',
      '#5AA08D',
      '#4C92B1',
      '#C8707E',
      '#EEE117',
      '#E48E58',
      '#E28FAD',
      '#97F19E',
      '#5AA08D',
      '#4C92B1',
      '#C8707E',
      '#EEE117',
      '#E48E58',
      '#E28FAD',
      '#97F19E',

      // '#87EDED',
      // "#A3DA9A",
      // "#F6C87E",
      // "#C888ED",
      // '#F67E7E',
      // '#9B8EDC',
      // '#B7ADE6',
      // '#E4E0F5',
      // '#8A7AD6',
      // '#A69AE0',
      // '#D9D9D9',
      // '#5039BB',
      // '#F37FB7'
    ];

    let totalUserActivity = 0;
    productwise_activity.forEach((d) => (totalUserActivity += d.total));

    return (
      <>
        <Col className='gutter-row' span={12}>
          <Card
            size='small'
            style={{ height: '100%' }}
            headStyle={{ display: 'none' }}
            bodyStyle={{ padding: '24px' }}
            // extra={
            //   <Tooltip title={`Last updated at ${moment(grid_metrics && grid_metrics.lastUpdated).format("lll")}. Click to reload.`}>
            //     <Button
            //       size='small'
            //       type='link'
            //       shape='circle'
            //       onClick={() => this.updateGridMetrics()}
            //       icon={<ReloadOutlined spin={loading} />}
            //     />
            //   </Tooltip>
            // }
          >
            <Row>
              <Col span={24}>
                <Row>
                  <Col span={12}>
                    <Typography.Title
                      level={5}
                      style={{ fontWeight: 'normal' }}
                    >
                      User activities (30 days)
                    </Typography.Title>
                  </Col>
                  <Col span={12}>
                    <Typography.Title level={2} style={{ textAlign: 'right' }}>
                      {totalUserActivity}
                    </Typography.Title>
                  </Col>
                </Row>
                <ResponsiveContainer
                  width={'100%'}
                  /* width={400} */ height={300}
                >
                  <PieChart>
                    <Pie
                      dataKey='total'
                      data={productwise_activity}
                      cx='50%'
                      cy='50%'
                      // outerRadius={'100%'}
                      fill='#8884d8'
                      label={false}
                    >
                      {productwise_activity.map((data, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={COLORS[index % COLORS.length]}
                        />
                      ))}
                    </Pie>
                    <Legend
                      layout={'horizontal'}
                      // align='right'
                      // verticalAlign='right'
                      formatter={this.getLegendText}
                    />
                    <ReTooltip
                    //   contentStyle={localStorage.getItem("theme") === "dark" && { backgroundColor: "#000" }}
                    //   labelStyle={localStorage.getItem("theme") === "dark" && { color: "white" }}
                    />
                  </PieChart>
                </ResponsiveContainer>
              </Col>
            </Row>
          </Card>
        </Col>
        <Col className='gutter-row' span={12}>
          <Card
            size='small'
            // title='User activities (60 days)'
            style={{ height: '100%' }}
            bodyStyle={{ padding: '24px' }}
            headStyle={{ display: 'none' }}
            // extra={
            //   <Tooltip title={`Last updated at ${moment(grid_metrics && grid_metrics.lastUpdated).format("lll")}. Click to reload.`}>
            //     <Button
            //       size='small'
            //       type='link'
            //       shape='circle'
            //       onClick={() => this.updateGridMetrics()}
            //       icon={<ReloadOutlined spin={loading} />}
            //     />
            //   </Tooltip>
            // }
          >
            <Row>
              <Col span={24}>
                <Typography.Title level={5} style={{ fontWeight: 'normal' }}>
                  User adoption report (60 days){' '}
                </Typography.Title>
                <ResponsiveContainer width={'100%'} height={300}>
                  <AreaChart data={day_by_day_activities}>
                    <ReTooltip
                      contentStyle={
                        localStorage.getItem('theme') === 'dark' && {
                          backgroundColor: '#000',
                        }
                      }
                    />
                    <XAxis dataKey={'date'} />
                    <Area
                      type='monotone'
                      dataKey='activities'
                      fill={
                        localStorage.getItem('theme') === 'default'
                          ? '#402E96'
                          : '#664af0'
                      }
                      // strokeWidth={2}
                      // fillOpacity={1}
                    />
                  </AreaChart>
                </ResponsiveContainer>
              </Col>
            </Row>
          </Card>
        </Col>
      </>
    );
  }
}

export default withRouter(
  // connect({}, {})(Dashboard)
  DashboardChart
);
